import * as React from 'react';
import { OrganizationOwner, WorkgroupListing } from '../../../amorg-common';
import { portalClientApi } from '../../../api/portalClientApi';
import { SingleColumnLayout } from '../../_layouts/SingleColumnLayout';
import { PageHeader } from '../../../designSystem/PageHeader';
import { EmployeePageWrapper } from '../../_pageWrappers/EmployeePageWrapper';
import { OrgChart } from '../../organization/_components/OrgChart';

// type loginMethod = 'none' |'magicLink';

export function PortalOrganizationPage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalOrganizationPageContent />
        </EmployeePageWrapper>
    );
}

function PortalOrganizationPageContent(): JSX.Element
{
    const [state, setState] = React.useState<{
        workgroupList: WorkgroupListing[];
        organizationOwner: OrganizationOwner | null;
    }>(
        {
            workgroupList: [],
            organizationOwner: null
        }
    );

    React.useEffect(() => {
        const getData = async () => {
            const workgroupList = await portalClientApi.getWorkgroups();
            const organizationOwner = await portalClientApi.getOwner();
            setState(
                {
                    workgroupList,
                    organizationOwner
                }
            );
        };
        getData();
    }, []);


    return (
        <>

            <PageHeader narrow headerText={`Din arbejdsmiljøorganisation`} />
            <SingleColumnLayout narrow>
                <OrgChart
                    allWorkgroups={state.workgroupList}
                    organizationOwner={state.organizationOwner}
                />
            </SingleColumnLayout>
        </>
        
    );
}